<template>
    <div class="nav-login">
        <div v-if="login" class="login-show">
            <a v-if="can('/admin/*')" @click="dialogVisible =true"><i class="el-icon-upload"></i>上传文件</a>
            <template>
                <el-dialog :visible.sync="dialogVisible">
                    <template>
                        <el-radio v-model="radio" label="1" :change="changeAction()">检验检测</el-radio>
                        <el-radio v-model="radio" label="2" :change="changeAction()">计量校准</el-radio>
                    </template>
                    <el-upload :action="action"
                               :auto-upload="false"
                               :headers="header"
                               :on-success="getProgress"
                               ref="upload">
                        <el-button class="marWrap" slot="trigger" size="small" type="primary">选取文件</el-button>
                        <el-button class="marWrap" style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                    </el-upload>
                    <div class="marWrap" v-if="showProgress">
                        <span class="analyze">解析进度：</span>
                        <el-progress :percentage="progress" :color="customColor"></el-progress>
                    </div>
                </el-dialog>
            </template>
            <a v-if="can('/admin/*')" @click="$router.push(`/datacount`)" target="_blank"><i class="el-icon-s-data"></i>数据统计</a>
            <span class="user-avatar" v-if="user && user.imageId && user.imageId !== null"><el-avatar
                    src="`url('/api/file/download/${user.imageId}')`" :size="20"></el-avatar></span>
            <span class="user-avatar" v-else><el-avatar icon="el-icon-user-solid" :size="20"></el-avatar></span>
            <span class="username">{{user.name || user.username}}</span>
            <span @click="loginOut">退出登录</span>
        </div>
        <span v-else class="login" @click="isShow" style="cursor: pointer">登录</span>
        <login/>
    </div>
</template>

<script>
  import Http from '../../utils/Http'
  import Auth from '@/auth/Auth'
  import Login from '@/components/common/Login'

  export default {
    data () {
      return {
        dialogVisible: false,
        radio: '1',
        user: {},
        login: false,
        action: `/data/api/detection/add`,
        header: {Authorization: 'Bearer ' + Auth.getAccessToken()},
        customColor: '#409eff',
        progress: 0,
        showProgress: false
      }
    },
    methods: {
      can (permission) {
        return Auth.can(permission)
      },
      isShow () {
        this.$store.commit('isShow')
      },
      getUser () {
        Http.fetch(
          `/api/admin/user`,
          {},
          result => {
            if (result.status === 'ok') {
              this.user = result.data
            } else {
              this.$message.error(result.message)
            }
          }
        )
      },
      checkLogin () {
        if (Auth.isLogin()) {
          this.login = true
          this.getUser()
          this.roles = Auth.getRoles()
        }
      },
      loginOut () {
        this.$alert('确定退出登录？', '退出登录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Auth.setAccessToken('')
          Auth.setPermissions({})
          Auth.setRoles({})
          Auth.setUser('')
          this.$router.push({name: 'home'})
          this.login = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消退出'
          })
        })
      },
      submitUpload () {
        this.$refs.upload.submit()
      },
      getProgress (response) {
        if (response.status === 200) {
          this.showProgress = true
          let _this = this
          let timer = setInterval(function () {
            Http.fetch(
              `/data/api/parse/progress`,
              {},
              result => {
                if (result.status === 200) {
                  _this.progress = result.data
                  if (_this.progress === 100) {
                    clearInterval(timer)
                    _this.$refs.upload.clearFiles()
                    _this.$message({
                      message: result.message,
                      type: 'success'
                    })
                  }
                } else {
                  this.$message.error(result.message)
                }
              }
            )
          }, 3000)
        } else {
          this.$message.error(response.message)
        }
      },
      changeAction () {
        if (this.radio === '1') {
          this.action = '/data/api/detection/add'
        } else {
          this.action = '/data/api/metering/add'
        }
      }
    },
    mounted () {
      this.checkLogin()
    },
    components: {
      Login
    }
  }
</script>

<style scoped>
    .marWrap{
        margin: 15px 0;
    }
    .nav-login {
        display: inline-block;
    }
    .nav-login .login-show a {
        padding: 0 20px;
        cursor: pointer;
    }
    .nav-login .login-show span {
        cursor: pointer;
    }
    .nav-login .el-avatar {
        display: inline;
    }
    .nav-login .analyze{
        float: left;
        margin-right: 5px;
    }
    .nav-login>>>.el-progress-bar{
        float: left;
        margin-top: 10px;
        width: 85%;
    }

</style>



// WEBPACK FOOTER //
// src/components/common/NavLogin.vue